import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { showModal, closeWebSideNav } from 'modules/navigation/navigation.actions';
import NavProfileComponent from 'modules/profile/navProfile.component';
import CommunityNav from 'modules/community/communityNav.component';
import SideNavFooter from 'modules/navigation/sideNavFooter.component';
import { layout } from 'app/styles';
import MenuIcon from 'modules/ui/web/menuIcon.component';
import { SIDE_NAV_PADDING } from 'styles/layout';
import history from 'modules/navigation/history';
import { Row, View, Image, Pressable } from 'modules/styled';
import { View as RView } from 'react-native';

class SideNav extends Component {
  componentDidMount() {
    history.listen(() => {
      this.props.actions.closeWebSideNav();
    });
  }

  render() {
    const { community, actions, notif, navigation } = this.props;
    const { screenSize } = navigation;
    const logoLink = `/${community || 'relevant'}/new`;
    const top = notif.promptType ? layout.BANNER_PROMPT_HEIGHT : [0];

    return (
      <View
        webContainerSx={{
          position: 'sticky',
          top: notif.promptType ? layout.BANNER_PROMPT_HEIGHT : [0],
          zIndex: 100,
        }}
        style={{
          position: 'sticky',
        }}
        sx={{
          zIndex: 100,
          top: 0,
        }}
      >
        <Row
          sx={{
            bg: 'lightGreyBg',
            width: layout.sideNavWidth,
            maxWidth: layout.sideNavWidth,
            zIndex: 100,
            height: '100vh',
            paddingBottom: top,
            variant: 'borders.navBorder',
            borderRightWidth: 1,
          }}
        >
          <div
            style={{
              flexDirection: 'column',
              display: 'block',
              overflow: 'scroll',
              WebkitOverflowScrolling: 'touch',
              flex: 1,
              width: layout.sideNavWidth,
            }}
          >
            <RView
              style={{
                position: screenSize ? 'relative' : 'sticky',
                zIndex: 10,
                top: 0,
              }}
            >
              <Row
                sx={{
                  px: [2, SIDE_NAV_PADDING],
                  height: layout.headerHeight,
                  bg: 'lightGreyBg',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  variant: 'borders.navBorder',
                  borderBottomWidth: 1,
                }}
              >
                <Pressable sx={{ alignItems: 'center' }} to={logoLink}>
                  <Image
                    sx={{ height: 4 * 8, width: 22 * 8 }}
                    resizeMode={'contain'}
                    source={'/img/logo-opt.png'}
                    alt={'Relevant'}
                  />
                </Pressable>
                <MenuIcon />
              </Row>
            </RView>
            <NavProfileComponent />
            <CommunityNav
              {...this.props}
              viewCommunityMembers={() => {
                actions.showModal('communityMembers');
              }}
              showSettings={() => {
                actions.showModal('communitySettings');
              }}
            />
            <SideNavFooter />
          </div>
        </Row>
      </View>
    );
  }
}

SideNav.propTypes = {
  actions: PropTypes.object,
  community: PropTypes.string,
  navigation: PropTypes.object,
  notif: PropTypes.object,
};

const mapStateToProps = (state) => ({
  community: state.auth.community,
  isAuthenticated: state.auth.isAuthenticated,
  navigation: state.navigation,
  notif: state.notif,
});

export default connect(mapStateToProps, (dispatch) => ({
  actions: bindActionCreators(
    {
      showModal,
      closeWebSideNav,
    },
    dispatch
  ),
}))(SideNav);
